function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import { GENERIC_PURECARS_DOMAIN } from '@signal/utils/constants';
import { setCookie } from '@signal/utils/cookies';
import { AuthError } from '@signal/utils/errors';
import { PC_AUTH_COOKIE, PC_AUTH_COOKIE_QA } from '../auth';
import { getAuthFailureRedirectUrl } from '../auth/utils/redirects';
import { useSWRWithCache } from './hooks';
import { createFetchContext, createFetchContextProps } from './FetchContext';
/**
 * @component ContextFetcher
 * The <ContextFetcher> React component which handles a single context fetch
 */

export function ContextFetcher(_ref) {
  var children = _ref.children,
      _ref$fetchHook = _ref.fetchHook,
      fetchHook = _ref$fetchHook === void 0 ? useSWRWithCache : _ref$fetchHook,
      _ref$FetchContext = _ref.FetchContext,
      FetchContext = _ref$FetchContext === void 0 ? createFetchContext() : _ref$FetchContext,
      hookParams = _objectWithoutProperties(_ref, ["children", "fetchHook", "FetchContext"]);

  var fetchContext = createFetchContextProps({
    isFetching: true
  });

  try {
    var result = fetchHook(hookParams);

    if (result) {
      fetchContext.isFetching = false;
      fetchContext.response = result;
    }
  } catch (error) {
    // TODO: we need to figure out which cookie to delete in which environment
    // (maybe should be configured from root eventually)
    if (error instanceof AuthError) {
      // if we see an auth error, our cookies must not be valid (prod/QA shift).  Clear cookies and reload
      setCookie({
        name: PC_AUTH_COOKIE,
        domain: GENERIC_PURECARS_DOMAIN,
        value: ''
      });
      setCookie({
        name: PC_AUTH_COOKIE_QA,
        domain: GENERIC_PURECARS_DOMAIN,
        value: ''
      });
      var authRedirect = getAuthFailureRedirectUrl();
      window.location.href = authRedirect;
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }

    throw error;
  }

  return /*#__PURE__*/React.createElement(FetchContext.Provider, {
    value: fetchContext
  }, children);
}
/**
 * @function castFetchContext - allows you to create a memoized FetchContext that is cast to a particular generic
 * @return returns a ContextFetcher with the specified <T> generic applied
 */

export function castFetchContext() {
  return /*#__PURE__*/memo(function (props) {
    return ContextFetcher(props);
  });
} // note - do not use this in typescript, use castFetchContext instead

export default /*#__PURE__*/memo(ContextFetcher);